import axios from 'axios';

const API_URL = 'http://dev.ouicsport.fr/api/offer';

export const cancelOffer = (userId, purchaseId) => {
  let formData = new FormData();
  formData.append('userId', userId);
  formData.append('purchaseId', purchaseId);
  
  return axios.post(`${API_URL}/cancel`, formData);
};

export const confirmCancellation = (userId, purchaseId) => {
  let formData = new FormData();
  formData.append('userId', userId);
  formData.append('purchaseId', purchaseId);
  
  return axios.post(`${API_URL}/cancel/confirmation`, formData);
};


